/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/203-earth': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zm0 15a6.96 6.96 0 01-2.769-.57l3.643-4.098A.503.503 0 009 10V8.5a.5.5 0 00-.5-.5C6.735 8 4.872 6.165 4.854 6.146A.5.5 0 004.5 6h-2a.5.5 0 00-.5.5v3a.5.5 0 00.276.447L4 10.809v2.936A6.992 6.992 0 011 8a6.97 6.97 0 01.674-3H3.5c.133 0 .26-.053.354-.146l2-2A.5.5 0 006 2.5V1.29A6.989 6.989 0 018 1c1.1 0 2.141.254 3.067.706A2.98 2.98 0 0010 3.999c0 .801.312 1.555.879 2.121a2.994 2.994 0 002.268.875c.216.809.605 2.917-.131 5.818a.466.466 0 00-.013.082 6.979 6.979 0 01-5.002 2.104z"/>'
  }
})
